// This file is generated by LiquidTypesGenerator.php
// Do not edit it manually
// Mirrors Article::LIQUID_TYPES on the backend: these are the article types that are still
// covered by the Kostenträger (health insurance) for public-insurance patients.
export const LIQUID_ARTICLE_TYPES = ["essence", "xtracts"] as const

export type LiquidArticleType = (typeof LIQUID_ARTICLE_TYPES)[number]

export function isLiquidArticleType(type: string | null | undefined): type is LiquidArticleType {
    return LIQUID_ARTICLE_TYPES.includes(type as LiquidArticleType)
}
